import { Injectable } from '@angular/core';
import { ExternalCashTransferStore } from './external-cash-transfer.store';
import { ApiService } from '../../shared/services/core/api.service';
import { Observable } from 'rxjs';
import { VerifyEmailAddressRequest } from './models/verify-email-address-request.model';
import { map, tap, mapTo, catchError } from 'rxjs/operators';
import { TransferFundsRequest } from './models/transfer-funds-request.model';
import { ExternalCashTransferViewModel } from './models/external-cash-transfer-view.model';
import { MemberQuery } from '../member/member.query';
import { ErrorStateService } from '../../shared/services/core/error.service';
import { HttpErrorResponse } from '@angular/common/http';
import { UserContext } from '../member/models/user-context.model';

@Injectable({ providedIn: 'root' })
export class ExternalCashTransferService {
  constructor(
    private externalTransferStore: ExternalCashTransferStore,
    private api: ApiService,
    private memberQuery: MemberQuery,
    private errorService: ErrorStateService
  ) {}

  /** Verify email address exists on external api */
  verifyEmailAddress(verifyEmailAddress: VerifyEmailAddressRequest): Observable<ExternalCashTransferViewModel> {
    this.externalTransferStore.setLoading(true);
    const request$: Observable<ExternalCashTransferViewModel> = this.api
      .post('provider/verifyexternalemail', verifyEmailAddress)
      .pipe(
        map((x) => x as ExternalCashTransferViewModel),
        tap((response) => {
          if (response === null) {
            return response;
          }
          response.TransferAmount = verifyEmailAddress.Amount;
          response.EmailAddress = verifyEmailAddress.EmailAddress;
          this.externalTransferStore.upsert(response.UniqID, response);
          return response;
        })
      );

    return request$;
  }

  /** Transfer funds from current account to target */
  transferFunds(transfer: ExternalCashTransferViewModel, selectedMemberId?: string): Observable<null> {
    if (!selectedMemberId && transfer.Accounts[0].MemberIDs.length > 0) {
      selectedMemberId = transfer.Accounts[0].MemberIDs[0];
    }

    if (!selectedMemberId) {
      return new Observable<null>();
    }

    let userContext = this.memberQuery.getValue().user as UserContext;
    let transferRequest = new TransferFundsRequest(
      userContext.memberId,
      +userContext.externalRef,
      selectedMemberId,
      transfer.Accounts[0].AccountID,
      transfer.TransferAmount * 100,
      transfer.EmailAddress
    );

    const request$: Observable<null> = this.api.post('provider/transferfundsexternal', transferRequest).pipe(
      catchError((err: HttpErrorResponse) => {
        this.errorService.clearErrors();
        this.errorService.addError(err.error.toString());
        throw err;
      }),
      mapTo(null)
    );

    return request$;
  }
}
